import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';

import {
  isValidNameWithSpace,
  renderAutoCompleteSingleSelect,
  renderTextField,
  renderDateField,
  renderCheckBox,
} from '../../components/reduxFields';
import { saveDoucumentUpload } from './actions/PatientActions';
import { CommonButton } from '../../components/buttons';
import { checkFieldExistence, clearFieldErrorArray } from '../AppConfig/actions/index';
import UploadDocumentScreen from './components/uploadDocuments/UploadDocumentScreen';
// import { displayCustomError } from '../../../src/actions/utilAction'
import folderNames from '../../constants/FolderNameConstant';

const validate = (values) => {
  const errors = {};
  if (!values.documntType) {
    errors.documntType = 'Please select document type';
  }
  if (!values.documentTitle) {
    errors.documentTitle = 'Please enter title';
  }
  if (!values.docTypeTitle) {
    errors.docTypeTitle = 'Please enter document type title';
  }
  return errors;
};
/**
 * Dialog content can be scrollable.
 */
class UploadDocumentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      file: null,
      base64Img: null,
      base64String: '',
      documentTitle: '',
      documentTypeTitle: '',
      documentType: props.documentTypes,
      selectedDocTypeId: '',
      isValidFileSize: false,
      expiryDate: null,
      documentTypeLabel: '',
      isActive: null,
      userDocumentSubFoldersFiltered:[],
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.documentTitleHandler = this.documentTitleHandler.bind(this);
    this.documentTypeTitleHandler = this.documentTypeTitleHandler.bind(this);
    this.isActiveHandler = this.isActiveHandler.bind(this);
  }

  handleNewRequestNew(input, selectedValue, label) {
    input.onChange(selectedValue.value);    
    if(label === 'FOLDER')
    { 
        let userDocumentSubFoldersFiltered = this.props.userDocumentSubFolders.filter((obj) => obj.masterFolderId === selectedValue.value);
        this.setState({
            userDocumentSubFoldersFiltered: userDocumentSubFoldersFiltered
        });
    }
}

  documentTitleHandler = (e) => {
    this.setState({
      documentTitle: e.target.value,
    });
  }

  documentTypeTitleHandler = (e) => {
    this.setState({
      documentTypeTitle: e.target.value,
    });
  }

  isActiveHandler = (e) => {
    this.setState({
        isActive: e.target.checked,
    });    
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

    if (nextProps.uploadDocumentObj) {     
      this.setState({ 
        documntType: this.state.documentType ? this.state.documentType : nextProps.uploadDocumentObj.documentTypeId,
        expiryDate: this.state.expiryDate ? this.state.expiryDate : nextProps.uploadDocumentObj.expiration,
        documentTitle: this.state.documentTitle ? this.state.documentTitle : nextProps.uploadDocumentObj.documentTitle,
        documentTypeTitle: this.state.documentTypeTitle ? this.state.documentTypeTitle : nextProps.uploadDocumentObj.otherDocumentType,
        selectedDocTypeId : this.state.selectedDocTypeId ? this.state.selectedDocTypeId : nextProps.uploadDocumentObj.documentTypeId,
        isActive: this.state.isActive != null ? this.state.isActive : nextProps.uploadDocumentObj.isActive,        
        documentTypeLabel : this.state.documentTypeLabel ? this.state.documentTypeLabel : nextProps.uploadDocumentObj.documentTypeName.indexOf('(') > 0 ? 'OTHER' : '' 
      });
    }
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'value': value,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  calculateFileSizehandler = (files) => {
    let totalFileSize = 0;
    let fileSizeInKB = 0;
    // @desc - define const max upload file size 5MB
    let totalFileSizeInMB = 0;
    const fileSize5MB = 20.00;
    files.map((obj, i) => {
      totalFileSize = totalFileSize + obj.size;
      totalFileSizeInMB = ((totalFileSize / 1024) / 1024).toFixed(2);
      fileSizeInKB = Math.round(obj.size / 1024); // converted bytes(incoming file size) to KB.
      // 1024kb = 1MB
      let fileSizeInMB = Math.round((obj.size / 1024) / 1024);
      let fileSizeInMBFixTo2Decimal = fileSizeInMB.toFixed(2);
      return fileSizeInKB >= 1024 ? `${fileSizeInMBFixTo2Decimal}MB` : `${fileSizeInKB}KB`;
    });

    if (parseFloat(fileSizeInKB) === 0.00 || parseFloat(totalFileSizeInMB) > parseFloat(fileSize5MB)) {
      this.setState({ isValidFileSize: false });
    } else {
      this.setState({ isValidFileSize: true });
    }
  };

  getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
      let reader = new FileReader();
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    this.setState({ selectedDocTypeId: '', documentTypeLabel: '' },()=>{
      this.setState({ selectedDocTypeId: selectedRecord.value, documentTypeLabel: selectedRecord.label });
    });    
  };

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

  // _returnFolderNameBasedOnCondition(formData){
  //   if(formData.masterFolderId === 0 && formData.subFolderId === 0){
  //     return folderNames.MAIN
  //   }else if (formData.masterFolderId && formData.subFolderId === 0){
  //     return folderNames.MASTER
  //   }else {
  //     return folderNames.SUB
  //   }
  // }

  onSubmitHandler = (formData) => {
    let folderName = this.props.folderName   
    let self = this;
    let uploadDocumentObj = {};

    if(this.props.uploadDocumentObj === null)
    {
      let fileArr = this.refs.child.handleClick();
      let base64Array = [];
      let base64String = '';
      let objInside = {};
    
      fileArr.forEach((obj) => {
        let fileExtension = obj.name.split('.').pop().toLowerCase();
        let promise = this.getBase64(obj);
        promise.then(function (result) {
          let base64pre = `${result}`;
          let newBase64pre = base64pre.replace(/^data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,/, '');
          let finalBase64pre = `"${newBase64pre}": "${fileExtension}"`;
          base64String = `${finalBase64pre}`;
          base64Array.push(base64String);

          objInside = base64Array.reduce(function (acc, cur, i) {
            acc[i] = cur;
            return acc;
          }, {});

          uploadDocumentObj = {
            'userId': self.props.UserID,
            'base64': objInside,
            'documentTitle': self.state.documentTitle,
            'documentTypeId': self.state.selectedDocTypeId,
            'otherDocumentType': self.state.documentTypeTitle,
            'key': 'PATIENT',
            'expiration': self.state.expiryDate,            
            'isActive': self.state.isActive,        
            'masterFolderId': formData.masterFolderId || null,
            'subFolderId': formData.subFolderId || null,
            'oldFolderName' : folderName
          };
          if (base64Array.length === fileArr.length) {
            self.props.saveDoucumentUpload(uploadDocumentObj, self.props.UserID);
          }
        });
      });
    }
    else
    {
      uploadDocumentObj = {
        'id': this.props.uploadDocumentObj.id,
        'userId': self.props.UserID,
        'base64': {},
        'documentTitle': formData.documentTitle,
        'documentTypeId': self.state.selectedDocTypeId,
        'otherDocumentType': self.state.documentTypeTitle,
        'key':  'PATIENT',
        'expiration': self.state.expiryDate,
        'isActive': formData.isActive,    
        'masterFolderId': formData.masterFolderId || null,
        'subFolderId': formData.subFolderId || null,    
        'oldFolderName' : folderName
      };     
      
      self.props.saveDoucumentUpload(uploadDocumentObj, self.props.UserID);
    }

    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    this.props.closeDialog();
    this.props.clearFieldErrorArray();
  } 

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.uploadDocumentObj !== null || this.state.isValidFileSize ?      
      <CommonButton
        label={this.props.uploadDocumentObj !== null ? 'Update' : 'Upload'}
        type="submit" primary={true}
        onTouchTap={handleSubmit(this.onSubmitHandler.bind(this))} /> :
        <CommonButton primary={true} className="loader_btn" disabled={true} label="Upload" />;
    const actions = [
      <CommonButton className="mr-15 grey_btn" label="Cancel" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={this.props.uploadDocumentObj !== null ? 'Edit Uploaded Document' : 'Upload Document'}
          modal={false}
          open={this.state.open}
          actions={actions}
          autoScrollBodyContent={true}
        >
          <div className="row">
            <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
                <div className="row">
                  <div className='col-sm-6 require mt-35'>
                    <Field
                      name="documntType"
                      label="Document Type"
                      component={renderAutoCompleteSingleSelect}
                      options={this.state.documentType}
                      handleNewRequest={this.handleNewRequest}
                    />
                  </div>
                  <div className='col-sm-6'>
                    <Field
                      name="expiryDate"
                      placeholder="Expiration Date"
                      locale="en-US"
                      selected={this.state.expiryDate}
                      onDateChange={this.onDateChange}
                      openToYearSelection={true}
                      component={renderDateField} />
                  </div>
                </div>
                <div className="row">
                  {this.state.documentTypeLabel && this.state.documentTypeLabel.toUpperCase() === 'OTHER' ?
                    <div className='col-sm-6 require'>
                      <Field
                        autoFocus={true}
                        value={this.state.documentTypeTitle}
                        onChange={this.documentTypeTitleHandler}
                        name="docTypeTitle"
                        type="text"
                        maxLength="100"
                        floatingLabelText="Document Type Title"
                        normalize={isValidNameWithSpace}
                        component={renderTextField}
                        fullWidth={true}
                      />
                    </div> : ''
                  }
                  <div className='col-sm-6 require'>
                    <Field
                      value={this.state.documentTitle}
                      onChange={this.documentTitleHandler}
                      name="documentTitle"
                      type="text"
                      maxLength="100"
                      floatingLabelText="Title"
                      normalize={isValidNameWithSpace}
                      component={renderTextField}
                      fullWidth={true}
                    />
                  </div>
                  <div className="col-sm-6 require" style={{ marginTop: '40px' }}>
                      <Field
                          name={`masterFolderId`}
                          hintText="Folder"
                          handleNewRequest={(input, selectedValue) => this.handleNewRequestNew(input, selectedValue, 'FOLDER')}
                          options={this.props.userDocumentMasterFolders}
                          component={renderAutoCompleteSingleSelect}
                      />
                  </div>
                  <div className="col-sm-6" style={{ marginTop: '30px' }}>
                      <Field
                          name={`subFolderId`}
                          hintText="Sub Folder"
                          handleNewRequest={(input, selectedValue) => this.handleNewRequestNew(input, selectedValue, 'SUB FOLDER')}
                          options={(this.props.subFolderId ? this.props.userDocumentSubFolders : this.state.userDocumentSubFoldersFiltered)}
                          component={renderAutoCompleteSingleSelect}
                      />
                  </div>
                  <div className="col-sm-6">
                    <Field
                      className="mt20 mb0"
                      name="isActive"
                      label="Is Active"
                      onChange={(e) => this.isActiveHandler(e)}                  
                      component={renderCheckBox}
                    />
                </div>
                </div>
                {this.props.uploadDocumentObj === null ?
                  <div className="row">
                    <div className='col-sm-12 require mt-35'>
                      <UploadDocumentScreen ref="child" calculateFileSizehandler={this.calculateFileSizehandler.bind(this)} />
                    </div>
                  </div>
                : null}
              </form>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

// const selector = formValueSelector('UploadDocumentModalForm');
const mapStateToProps = (state, ownProps) => {
  let initialData = null;  
  let subFolderId = 0;
  initialData = { isActive: true };

  if (ownProps.uploadDocumentObj) {
    initialData = {
      documntType: ownProps.uploadDocumentObj.documentTypeId,
      expiryDate: ownProps.uploadDocumentObj.expiration,
      documentTitle: ownProps.uploadDocumentObj.documentTitle,
      docTypeTitle: ownProps.uploadDocumentObj.otherDocumentType,
      isActive: ownProps.uploadDocumentObj.isActive,
      masterFolderId: ownProps.uploadDocumentObj.masterFolderId,
      subFolderId: ownProps.uploadDocumentObj.subFolderId,
    };
    subFolderId = ownProps.uploadDocumentObj.subFolderId
  }
  return {
    initialValues: initialData,
    subFolderId: subFolderId,
    // uploadDocumentObj: ownProps.uploadDocumentObj ? ownProps.uploadDocumentObj : null,
    loading: state.patient.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
  }

};


UploadDocumentModal = reduxForm({
  form: 'UploadDocumentModalForm', // a unique identifier for this form
  validate,
  enableReinitialize: true,
})(UploadDocumentModal);

export default connect(mapStateToProps, { saveDoucumentUpload, clearFieldErrorArray, checkFieldExistence })(UploadDocumentModal);



// WEBPACK FOOTER //
// ./src/modules/patients/patient_profile_client_modal.js